import 'regenerator-runtime/runtime';
import 'custom-event-polyfill';
import 'eligrey-classlist-js-polyfill';
import initSentry from '../modules/sentry';

initSentry('Blog');
